module.exports = __webpack_public_path__ + "static/media/userDefault.dc8b1732.png";